import type { IUser } from "../types/user.types";

export class EditorConfigModel {
  private _user: IUser | null = null;
  private _initialConfig: any = {};
  private _config: any = {};

  constructor(initialConfig: any, user: IUser | null) {
    this._user = user;
    this._initialConfig = initialConfig;
    this.addUserData();
    this.addInitialConfig();
  }

  private addUserData() {
    if (!this._user) {
      console.warn(new Error('User is not defined'));
      return;
    }
    const userData = {
      userId: this._user.id,
      token: this._user.token,
    };
    this._config = Object.assign(this._config, userData);
  }

  private addInitialConfig() {
    if (!this._initialConfig) {
      console.warn(new Error('Initial config is not defined'));
      return;
    }
    this._config = Object.assign(this._config, this._initialConfig?.editorConfig);
  }

  get config() {
    return this._config;
  }
}